import React from 'react';
import { connect } from 'react-redux';

const MinicartButton = ({
    handleMinicartClick,
    cartQty,
    minicartAnimation
}) => (
    <button
        onClick={handleMinicartClick}
        className={
            minicartAnimation && cartQty > 0
                ? 'uiPopup__trigger uiPopup__trigger--cta uiPopup__trigger--animate'
                : 'uiPopup__trigger uiPopup__trigger--cta'
        }
    >
        <i className="fas fa-shopping-cart" />
        <span className="minicart_quantity">{cartQty}</span>
    </button>
);

const mapStateToProps = state => {
    const { cartQty } = state.cartReducer;
    const { minicartAnimation } = state.animationsReducer;

    return {
        cartQty: cartQty,
        minicartAnimation: minicartAnimation
    };
};

export default connect(mapStateToProps)(MinicartButton);



// WEBPACK FOOTER //
// ./src/components/Minicart/components/MinicartButton.jsx